<form [formGroup]="passForm" class="pb-10">
  <p class="text-center font-bold text-xl mb-0">Esqueceu a senha?</p>
  <p class="text-center text-gray-800 text-xs mt-0">
    Não se preocupe! Enviaremos uma nova<br />
    senha para seu e-mail.
  </p>
  <div class="block">
    <mat-form-field
      class="input-tg w-full"
      appearance="outline"
      hideRequiredMarker="true"
    >
      <mat-label>Email</mat-label>
      <input id="email" type="email" matInput formControlName="email" />
    </mat-form-field>
    <button
      mat-flat-button
      class="btn-tg w-full mb-4"
      [disabled]="!checkForm() || loading"
      (click)="sendForgot()"
    >
      @if (loading) {
        <mat-spinner
          diameter="22"
          class="loading-spinner"
          selected-track-color="red"
        ></mat-spinner>
      } @else {
        Confirmar
      }
    </button>
    <button mat-button class="btn-tg-white w-full" (click)="forgotPass()">
      voltar
    </button>
  </div>
</form>
